// extracted by css-extract-rspack-plugin
export default {"colorWhite":"#fff","dialog":"dialog__dialog____7Z7X","root":"dialog__root___I9Pt8"};